import React from 'react';

import { CommodityCreateDetails } from '@components/utilities/Commodity/CommodityCreateDetails';

export const AddCommodity: React.FC = () => <CommodityCreateDetails type="create" />;
